import React, { useContext } from 'react'
import { Dropdown } from 'semantic-ui-react'
import DataContext from '../contexts/DataContext'

const CountryDropdown = ({ defaultCountry, setCountry }) => {
  const { countries } = useContext(DataContext)
  const getCountryCode = (countryName) =>
    countries.find((c) => c.name === countryName)?.code
  const getCountryName = (countryCode) =>
    countries.find((c) => c.code === countryCode)?.name
  const countryOptions = countries.map((c) => ({
    key: c.code,
    value: c.code,
    text: c.name,
    flag: c.code,
  }))
  return (
    <Dropdown
      placeholder="Select Country"
      fluid
      search
      selection
      value={getCountryCode(defaultCountry)}
      options={countryOptions}
      onChange={(e, { value }) => setCountry(getCountryName(value))}
    />
  )
}

export default CountryDropdown
